import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16, IcoChevronRight16 } from '@onefootprint/icons';
import type { ApiNodeDataInputSchema } from '@onefootprint/request-types/dashboard';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { NodeProps } from '@/components/playbook-builder/playbook-builder.types';
import { getSchemaProperties } from '../../utils/schema';
import ViewPropertyItem from '../view-prop-item';
const ViewSchema = t0 => {
  const $ = _c(17);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "inputSchema.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const schemasProperties = getSchemaProperties(node.data.schema);
  const [isExpanded, setIsExpanded] = useState(new Array(schemasProperties.length).fill(true));
  const t2 = "flex flex-col gap-4";
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <p className="text-label-2 text-primary">{t3}</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp2);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-body-2 text-tertiary">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isExpanded) {
    t8 = (t9, index) => {
      const {
        key,
        properties
      } = t9;
      return <div className="overflow-hidden" key={key}><button type="button" onClick={() => setIsExpanded(prev => {
          const newIsExpanded = [...prev];
          newIsExpanded[index] = !newIsExpanded[index];
          return newIsExpanded;
        })} className="flex items-center pb-2  w-full cursor-pointer"><div className="flex gap-3 items-center">{isExpanded[index] ? <IcoChevronDown16 /> : <IcoChevronRight16 />}<div className="flex gap-2 items-center"><span className="font-medium text-snippet-1 text-primary">{key}</span></div></div></button><AnimatePresence>{isExpanded[index] && <motion.div className="pl-4 ml-6 border-l border-tertiary" initial={{
            height: 0
          }} animate={{
            height: "auto"
          }} exit={{
            height: 0
          }} transition={{
            duration: 0.2
          }}><div className="flex flex-col gap-4">{properties.map(_temp3)}</div></motion.div>}</AnimatePresence></div>;
    };
    $[12] = isExpanded;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = schemasProperties.map(t8);
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <div className={t2}>{t7}{t9}</div>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default ViewSchema;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3(property) {
  return <ViewPropertyItem key={property.key} name={property.key} schema={property} isRequired={property.isRequired ?? false} />;
}